import { ethers } from 'ethers';
import SimpleCrypto from 'simple-crypto-js';
import { SHA256 } from 'crypto-js';

export async function createEncryptedPrivateKey(
  mnemonic: string,
  password: string,
  walletAddress: string,
) {
  const timestamp = Date.now();
  const wallet = ethers.Wallet.fromMnemonic(mnemonic);
  const signature = await wallet.signMessage(`${walletAddress}_${timestamp}`);
  const publicKey = wallet.publicKey;
  const crypto = new SimpleCrypto(password);
  const crypto2 = new SimpleCrypto(publicKey);
  const encryptedPrivateKey = crypto.encrypt(wallet.privateKey);
  const encryptionVerifier = crypto2.encrypt(encryptedPrivateKey);
  const hashedMnemonic = SHA256(mnemonic).toString();

  return {
    signature,
    publicKey,
    encryptedPrivateKey,
    encryptionVerifier,
    hashedMnemonic,
    timestamp,
  };
}
